export default __webpack_public_path__ + "static/media/padel-gold-cover.6bc876fb.png";